import React from 'react';
import { Typography } from '@mui/material';

interface SettingsCardProps {
    title: string;
    subtitle: string;
    icon: React.ReactNode;
    children: React.ReactNode;
}

export const SettingsCard: React.FC<SettingsCardProps> = ({ title, subtitle, icon, children }) => {
    return (
        <div className="bg-[#DCE7F6] rounded-[32px] shadow-sm overflow-hidden border border-white/20">
            <div className="p-8 sm:p-12">
                <div className="mb-10 flex items-center space-x-5">
                    <div className="bg-[#6366f1]/10 p-4 rounded-2xl">
                        {icon}
                    </div>
                    <div>
                        <Typography variant="h4" sx={{ fontWeight: 800, color: '#102A43', mb: 0.5 }}>
                            {title}
                        </Typography>
                        <Typography variant="body1" sx={{ color: '#486581' }}>
                            {subtitle}
                        </Typography>
                    </div>
                </div>
                {children}
            </div>
        </div>
    );
};
